// extracted by mini-css-extract-plugin
export var bodySections = "_4y-8";
export var gray = "_4y-7";
export var green = "_4y-4";
export var iconContainer = "_4y-9";
export var iconWidgetContainer = "_4y-1";
export var phoneIcon = "_4y-2";
export var red = "_4y-5";
export var statusDot = "_4y-3";
export var widgetContainer = "_4y-0";
export var yellow = "_4y-6";